import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
// import NavBar from '../components/Navbar';
import AdminNavBar from '../components/AdminNavBar';
import DownLoadMobileApp from '../components/DownLoadMobileApp';
import Footer from '../components/Footer';
import styled from '@emotion/styled';
import Navbar from '../components/Navbar/Navbar';
import AccessibilityModal from '../components/AccessibilityPointsModal';

const MainAppContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

function MainLayout() {
  const [userType, setUserType] = useState("");
  const [isAccessibilityOpen, setAccessibilityOpen] = useState(false);

  useEffect(() => {
    const type =  sessionStorage.getItem("userRole");
    setUserType(type);
  }, []);

 

  return (
    <MainAppContainer>
      {userType === "Admin" ? <AdminNavBar /> : <Navbar  setAccessibilityOpen={setAccessibilityOpen}/>}
      <Outlet />
      {userType !== "Admin" && <DownLoadMobileApp />}
      <Footer />

   <AccessibilityModal
        isOpen={isAccessibilityOpen}
        onClose={() => setAccessibilityOpen(false)}
      />
    
    </MainAppContainer>
  );
}

export default MainLayout;
